import {IsomorphicScript} from '@aboutyou/head-elements';
import React, {useEffect, useState} from 'react';

let initialized = false;
export const ScayleStateListener = ({
  isServerRendered,
}: {
  isServerRendered: boolean;
}) => {
  const [isListenerReady] = useState(() => initialized);

  useEffect(() => {
    initialized = true;
  }, []);

  if (isListenerReady) {
    return null;
  }

  if (isServerRendered) {
    return (
      <script
        id="scayle-state-listener"
        type="module"
        dangerouslySetInnerHTML={{__html: `(${initializeScript.toString()})()`}}
      />
    );
  }

  return (
    <IsomorphicScript
      id="scayle-state-listener"
      content={`(${initializeScript.toString()})()`}
    />
  );
};

const initializeScript = () => {
  const RETRY_DELAY_MS = 30;

  const tryAttach = () => {
    if (!window.scayleCheckoutEvents) {
      setTimeout(tryAttach, RETRY_DELAY_MS);
      return;
    }

    // Listen to scayle checkout state updates and re-dispatch them as custom events on the window object
    // https://scayle.dev/documentation/storefront/checkout/look-and-feel/dynamic-slots/integrating-slots#listening-for-a-change-in-the-order-state
    window.scayleCheckoutEvents.addEventListener(
      'state:updated',
      ({detail: {state}}) => {
        window.dispatchEvent(
          new CustomEvent('SCAYLE_STATE_UPDATE', {detail: {state}}),
        );
      },
    );
  };

  tryAttach();
};
